import React from 'react'

// @ts-ignore
import UserIcon from "../../../../../gd-components/icons/user-icon"

type Props = {
    filter              : any         // link to filter instance

    minItemsSelected    : number
}

export default class FilterMultiselect extends React.Component<Props> {

    static defaultProps = {
        minItemsSelected: 1 // min # of items that should be selected
    }

    constructor(props:Props) {
        super(props)
    }

    onItemClick = (value: any) => {
        const curValue = this.props.filter.getValue();
        let newValue;

        if (this.props.filter.isEnabled) {
            // multiselect mode
            newValue = gd.utils.toggleArrayValue(curValue, value);
        } else {
            // select one mode
            newValue = [value]
        }

        if (newValue.length >= this.props.minItemsSelected) {
            this.props.filter.setValue(newValue, false)
            this.setState({reRender: true})
        }
    }

    onCheckboxClick = (value: any) => {
        const curValue = this.props.filter.getValue()
        let newValue

        newValue = gd.utils.toggleArrayValue(curValue, value)

        // prevent unchecking all
        if (newValue.length >= this.props.minItemsSelected) {
            this.props.filter.setValue(newValue, false)
            this.setState({reRender: true})
        }
    }

    render() {
        const options = this.props.filter.getFilterOptions()
        const curValue = this.props.filter.getValue()

        return (
            <div className="block-content filter-multiselect">
                {_.map(options, (option: any)=>{
                    const selected = curValue.includes(option.value)

                    const classes = Classes("type-option", {
                        selected: selected
                    })
                    const checkBoxClasses = Classes('gd-cb-12',{
                        selected: selected
                    })

                    return (
                        <div key={option.value} className={classes}>
                            <div className  = {checkBoxClasses}
                                 onClick    = {this.onCheckboxClick.bind(this,option.value)}/>

                            <div className="name txt-truncate max-w-200" onClick={this.onItemClick.bind(this,option.value)}>
                                {option.user &&
                                    <UserIcon user={option.user} size="22"/>}

                                {option.icon &&
                                    <div className={Classes("option-icon", option.icon)}/>}

                                {option.label}
                            </div>
                            <div className="cf"/>
                        </div>
                    )
                })}
            </div>
        )
    }
}